var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.87844C1 9.51512 1.0933 9.15789 1.27096 8.84098L4.977 2.23022C5.30887 1.63823 5.88339 1.22131 6.54911 1.08937V1.08937C6.84681 1.03036 7.15319 1.03036 7.45089 1.08937V1.08937C8.11661 1.22131 8.69113 1.63823 9.023 2.23021L12.729 8.84098C12.9067 9.15789 13 9.51512 13 9.87844V9.87844C13 11.0501 12.0501 12 10.8784 12H3.12156C1.94986 12 1 11.0501 1 9.87844V9.87844Z",
    stroke: "#E48900",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.00002L7 7.66669",
    stroke: "#E48900",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.66667L7 10",
    stroke: "#E48900",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.16c5c748081a272815d07b0ab0a7619f.svg";
export { ForwardRef as ReactComponent };